module.exports = __webpack_public_path__ + "img/73.1b774790.jpg";